import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface SocialMediaRulesConfig {
  noPrivatePhoneAtWork: boolean;
  noPrivateCustomerPosts: boolean;
  onlyOfficialAccountsAllowed: boolean;
  strictDataPrivacyNoDMs: boolean;
}

export interface EquipmentRulesConfig {
  ipadBusinessOnly: boolean;
  noToolsHomeTaking: boolean;
  careAndLiabilityDuty: boolean;
  returnOnTermination: boolean;
}

export interface PEPapersInstructionState {
  selectedEmployeeId: string;
  effectiveDate: string;
  customRulesText: string;
  socialMedia: SocialMediaRulesConfig;
  equipment: EquipmentRulesConfig;
  setSocialMediaFlag: (key: keyof SocialMediaRulesConfig, value: boolean) => void;
  setEquipmentFlag: (key: keyof EquipmentRulesConfig, value: boolean) => void;
  setSelectedEmployeeId: (id: string) => void;
  setEffectiveDate: (date: string) => void;
  setCustomRulesText: (text: string) => void;
  resetConfig: () => void;
}

export const usePEPapersStore = create<PEPapersInstructionState>()(
  persist(
    (set) => ({
      selectedEmployeeId: 'all',
      effectiveDate: new Date().toISOString().split('T')[0],
      customRulesText: '',
      socialMedia: {
        noPrivatePhoneAtWork: true,
        noPrivateCustomerPosts: true,
        onlyOfficialAccountsAllowed: true,
        strictDataPrivacyNoDMs: true,
      },
      equipment: {
        ipadBusinessOnly: true,
        noToolsHomeTaking: true,
        careAndLiabilityDuty: true,
        returnOnTermination: true,
      },
      setSocialMediaFlag: (key, value) =>
        set((state) => ({
          socialMedia: { ...state.socialMedia, [key]: value },
        })),
      setEquipmentFlag: (key, value) =>
        set((state) => ({
          equipment: { ...state.equipment, [key]: value },
        })),
      setSelectedEmployeeId: (id) => set({ selectedEmployeeId: id }),
      setEffectiveDate: (date) => set({ effectiveDate: date }),
      setCustomRulesText: (text) => set({ customRulesText: text }),
      resetConfig: () =>
        set({
          selectedEmployeeId: 'all',
          effectiveDate: new Date().toISOString().split('T')[0],
          customRulesText: '',
          socialMedia: {
            noPrivatePhoneAtWork: true,
            noPrivateCustomerPosts: true,
            onlyOfficialAccountsAllowed: true,
            strictDataPrivacyNoDMs: true,
          },
          equipment: {
            ipadBusinessOnly: true,
            noToolsHomeTaking: true,
            careAndLiabilityDuty: true,
            returnOnTermination: true,
          },
        }),
    }),
    {
      name: 'pe-papers-store',
    }
  )
);
